/**
 * Zweck: Beschreibt class CustomerSurveyAnswer und ihren Daten- oder Funktionsvertrag.
 */
/**
 * Zweck: Beschreibt die TypeScript-Bausteine für den Frontend-Bereich frontend/src/app/models/customer-survey-answer.ts.
 */
export class CustomerSurveyAnswer {
  answer: any;
  comment: string;
}
